export var DeviceType = /*#__PURE__*/function (DeviceType) {
  DeviceType["Desktop"] = "desktop";
  DeviceType["Tablet"] = "tablet";
  DeviceType["Phone"] = "phone";
  return DeviceType;
}({});